import React, { memo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ApartmentsGallery from './ApartmentsGallery';
import { prettyNumber } from '../../../../utils/helpers';
import BinaModal from '../../../ReactModal';
import { useImageAlt } from '../../../../hooks/useImageAlt';

const ApartmentsModal = memo(({ apartment, isOpen, hide, imgDescription }) => {
  const { t } = useTranslation();

  const totalPrice = prettyNumber(
    Math.round(apartment.area * apartment.priceFrom)
  );
  const pricePerMeter = prettyNumber(apartment.priceFrom);
  const { currency } = apartment;
  const imgAlt = useImageAlt({
    rooms: apartment.rooms,
    area: apartment.area,
    description: imgDescription
  });

  const photos = apartment.photos.map((photo, i) => {
    return (
      <div className="apartments-modal__gallery-img" key={i}>
        <img src={photo.f660x496} alt={imgAlt} />
      </div>
    );
  });

  return (
    <BinaModal
      isOpen={isOpen}
      onRequestClose={hide}
      modalId="apartments"
      overlayClassName="modal__overlay-apartments"
      contentClassName="modal__content-apartments"
    >
      <div className="apartments-modal__container">
        <div className="apartments-modal__title">
          {t('residences.apartments_title')}
          <span
            className="apartments-modal__close-btn"
            onClick={hide}
            onKeyPress={hide}
            role="button"
            tabIndex="-1"
          >
            ×
          </span>
        </div>
        <div className="apartments-modal__content">
          <div className="apartments-modal__name">
            <span className="apartments-modal__name-value">
              {t('rooms.rooms_count', {
                count: apartment.rooms,
                postProcess: 'interval'
              })}
              {t('area_metres', { area: apartment.area })}
            </span>
          </div>
          <div className="apartments-modal__price">
            <Trans
              i18nKey="apartment_price"
              values={{
                price: totalPrice,
                currency
              }}
            >
              <span className="price-val">{{ totalPrice }}</span>
              <span className="price-cur">{{ currency }}</span>
            </Trans>
            <div className="apartments-modal__price-per-meter">
              <Trans
                i18nKey="apartment_price_per_meter"
                values={{
                  price: pricePerMeter,
                  currency
                }}
              >
                <span className="price-val">{{ pricePerMeter }}</span>
                <span className="price-cur">{{ currency }}</span>
              </Trans>
            </div>
          </div>
          <div className="apartments-modal__description">
            {apartment.repair && (
              <span>
                {t('apartment_repair', {
                  count: apartment.repair?.name
                })}
              </span>
            )}
            {apartment.balconiesCount && (
              <span>
                {t('apartment_balcon_count', {
                  count: apartment.balconiesCount
                })}
              </span>
            )}
            {apartment.balconiesCount && (
              <span>
                {t('apartment_bathroom_count', {
                  count: apartment.bathroomsCount
                })}
              </span>
            )}
          </div>
          <div className="apartments-modal__gallery">
            <ApartmentsGallery photos={photos} />
          </div>
        </div>
      </div>
    </BinaModal>
  );
});

ApartmentsModal.displayName = `ApartmentsModal`;

ApartmentsModal.propTypes = {
  isOpen: PropTypes.bool,
  apartment: PropTypes.object,
  hide: PropTypes.func,
  imgDescription: PropTypes.string
};

export default ApartmentsModal;
